import { useEffect, useMemo } from 'react';
import { useGoogleMap } from '@react-google-maps/api';
import { getBounds } from '@utils';

type TProps = {
	url?: string;
	data?: any;
}

export const GeoJsonLayer = (props: TProps) => {
	const {
		url,
		data
	} = props;
	const map = useGoogleMap();
	const dataLayer = useMemo(() => map && new google.maps.Data({ map: map }), [map]);

	useEffect(() => {
		dataLayer?.setStyle({
			strokeColor: '#F05637',
			fillColor: '#F05637',
			fillOpacity: 0.5,
			strokeOpacity: 0.5,
			strokeWeight: 2,
		});
	}, [map]);

	useEffect(() => {
		const handle = setTimeout(() => {
			const bounds: google.maps.LatLngBounds | null = dataLayer && getBounds(dataLayer);
			if (bounds) {
				map?.setCenter(bounds.getCenter());
				map?.fitBounds(bounds);
			}
		}, 500);

		return () => clearTimeout(handle);
	}, [url, data, map]);

	useEffect(() => {
		if (data?.features?.length) {
			dataLayer?.forEach(function (feature) {
				dataLayer.remove(feature);
			});
			dataLayer?.addGeoJson(data);
			return;
		}

		if (url) {
			dataLayer?.loadGeoJson(url);
		}
	}, [url, data, map]);

	return null;
};
